<template>
  <div class="article bg-white">
    <toolbar transparent fixed :logo="false">
      <template v-slot:right>
        <toolbar-add-to-schedule-button
          class="mr-1"
          :item-id="id"
          item-type="Article"
          page-content-type="article"
        />
        <toolbar-bookmark-button class="mr-1" :page-id="page_id" />
        <toolbar-share-button />
      </template>
    </toolbar>

    <template v-if="isPresent(banner) || isPresent(video)">
      <hero
        :image="banner"
        :video="video"
        :style-options="{ heightRatio: 150 }"
        safe-padding
      />
    </template>
    <template v-else>
      <div class="v-toolbar__spacer"></div>
    </template>

    <text-block-header :heading="title" :content="body" no-collapse />

    <cta-row v-if="has_cta">
      <v-button block raised large :to="cta_link">
        {{ cta_text }}
      </v-button>
    </cta-row>

    <v-made-with-movement v-if="!isDesktop" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import { isPresent } from "@/lib/utils"

import Toolbar from "@/components/Toolbar"
import ToolbarShareButton from "@/components/toolbar/ShareButton"
import ToolbarBookmarkButton from "@/components/toolbar/BookmarkButton"
import ToolbarAddToScheduleButton from "@/components/toolbar/AddToScheduleButton"
import Hero from "@/components/Hero"
import TextBlockHeader from "@/components/TextBlockHeader"
import CtaRow from "@/components/CtaRow"

export default {
  components: {
    Toolbar,
    ToolbarAddToScheduleButton,
    ToolbarShareButton,
    ToolbarBookmarkButton,
    Hero,
    TextBlockHeader,
    CtaRow
  },

  props: {
    id: { type: [Number, String], required: true },
    page_id: { type: Number, required: true },
    title: { type: String, default: "" },
    body: { type: String, default: "" },
    banner: { type: Object, default: () => ({}) },
    video: { type: Object, default: () => null },
    has_cta: { type: Boolean, default: false },
    cta_text: { type: String, default: "" },
    cta_link: { type: String, default: "#" }
  },

  head() {
    return {
      title: this.title
    }
  },

  computed: {
    ...mapState("responsive", ["isDesktop"])
  },

  methods: {
    isPresent
  }
}
</script>
